export const ACEPrint = {
  "panels": [{
    "index": 0,
    "paperType": "A4",
    "height": 297,
    "width": 210,
    "paperHeader": 111,
    "paperFooter": 759,
    "printElements": [{
      "options": {
        "left": 207,
        "top": 16.5,
        "height": 13.5,
        "width": 204,
        "fontSize": 18.75,
        "fontWeight": "700",
        "field": "title",
        "testData": "生产用辅料配制确认卡"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 477,
        "top": 7.5,
        "height": 102,
        "width": 100.5,
        "src": "/Content/assets/hi.png",
        "field": "img"
      },
      "printElementType": {
        "type": "image"
      }
    }, {
      "options": {
        "left": 121.5,
        "top": 46.5,
        "height": 9.75,
        "width": 136.5,
        "title": "款式",
        "field": "valueDesc",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 13.5,
        "top": 46.5,
        "height": 9.75,
        "width": 94.5,
        "title": "系列",
        "field": "group",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 121.5,
        "top": 61.5,
        "height": 9.75,
        "width": 136.5,
        "title": "名称",
        "field": "materialDescCn",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 15,
        "top": 61.5,
        "height": 9.75,
        "width": 93,
        "title": "面料",
        "field": "plus",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 121.5,
        "top": 79.5,
        "height": 9.75,
        "width": 136.5,
        "title": "打印日期",
        "field": "currentDate",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 15,
        "top": 79.5,
        "height": 9.75,
        "width": 93,
        "title": "款号",
        "field": "materialCode",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 13.5,
        "top": 96,
        "height": 9.75,
        "width": 94.5,
        "title": "关联款号",
        "field": "innerRemark",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 12,
        "top": 112.5,
        "height": 640.5,
        "width": 567,
        "field": "printData",
        "textAlign": "center",
        "tableHeaderBackground": "#ffffff",
        "lHeight": 400,
        "autoCompletion": true,
        "tableBodyRowHeight": 48,
        "fontFamily": "Microsoft YaHei",
        "columns": [
          [{
            "title": "编号名称",
            "field": "componentCode",
            "width": 71.96095320898259,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "itemCode"
          }, {
            "title": "类型",
            "field": "type",
            "width": 25.76266225035451,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "colorDesc"
          }, {
            "title": "规格",
            "field": "practicalSealingWidth",
            "width": 23.832825109886567,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "serial"
          }, {
            "title": "单件用量",
            "field": "componentUsage",
            "width": 52.12036822522535,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "colorDesc"
          }, {
            "title": "使用部位",
            "field": "usedPosition",
            "width": 43.493226860807255,
            "align": "center",
            "vAlign": "middle",
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "storageCode"
          }, {
            "title": "备注",
            "field": "remark",
            "width": 99.79363808018972,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "deliveryDate"
          }, {
            "title": "",
            "field": "color_0",
            "width": 64.31633626363534,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "colors",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }, {
            "title": "",
            "field": "color_1",
            "width": 58.64849955892088,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "color_1",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }, {
            "title": "",
            "field": "color_2",
            "width": 60.27324419012385,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "color_2",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }, {
            "title": "",
            "field": "color_3",
            "width": 66.79824625187398,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "color_3",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }]
        ]
      },
      "printElementType": {
        "title": "表格",
        "type": "tableCustom"
      }
    }, {
      "options": {
        "left": 214.5,
        "top": 763.5,
        "height": 9.75,
        "width": 136.5,
        "title": "技术部确认",
        "field": "productionManagerInfo"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 445.5,
        "top": 763.5,
        "height": 9.75,
        "width": 135,
        "title": "设计部确认",
        "field": "businessInfo"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 9,
        "top": 763.5,
        "height": 9.75,
        "width": 130.5,
        "title": "制表",
        "field": "userName",
        "testData": "张三"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 214.5,
        "top": 780,
        "height": 9.75,
        "width": 138,
        "title": "日期"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 447,
        "top": 781.5,
        "height": 9.75,
        "width": 135,
        "title": "日期"
      },
      "printElementType": {
        "type": "text"
      }
    }],
    "paperNumberLeft": 562.5,
    "paperNumberTop": 801,
    "topOffset": 16,
    "orient": 2
  }]
}
export const BDPrint = {
  "panels": [{
    "index": 0,
    "paperType": "A4",
    "height": 297,
    "width": 210,
    "paperHeader": 111,
    "paperFooter": 759,
    "printElements": [{
      "options": {
        "left": 207,
        "top": 16.5,
        "height": 13.5,
        "width": 204,
        "fontSize": 18.75,
        "fontWeight": "700",
        "field": "title",
        "testData": "生产用辅料配制确认卡"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 477,
        "top": 7.5,
        "height": 102,
        "width": 100.5,
        "src": "/Content/assets/hi.png",
        "field": "img"
      },
      "printElementType": {
        "type": "image"
      }
    }, {
      "options": {
        "left": 121.5,
        "top": 46.5,
        "height": 9.75,
        "width": 136.5,
        "title": "款式",
        "field": "valueDesc",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 13.5,
        "top": 46.5,
        "height": 9.75,
        "width": 94.5,
        "title": "系列",
        "field": "group",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 121.5,
        "top": 61.5,
        "height": 9.75,
        "width": 136.5,
        "title": "名称",
        "field": "materialDescCn",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 15,
        "top": 61.5,
        "height": 9.75,
        "width": 93,
        "title": "面料",
        "field": "plus",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 121.5,
        "top": 79.5,
        "height": 9.75,
        "width": 136.5,
        "title": "打印日期",
        "field": "currentDate",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 15,
        "top": 79.5,
        "height": 9.75,
        "width": 93,
        "title": "款号",
        "field": "materialCode",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 13.5,
        "top": 96,
        "height": 9.75,
        "width": 94.5,
        "title": "关联款号",
        "field": "innerRemark",
        "fontWeight": "600"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 12,
        "top": 112.5,
        "height": 640.5,
        "width": 567,
        "field": "printData",
        "textAlign": "center",
        "tableHeaderBackground": "#ffffff",
        "lHeight": 400,
        "autoCompletion": true,
        "tableBodyRowHeight": 48,
        "fontFamily": "Microsoft YaHei",
        "columns": [
          [{
            "title": "编号名称",
            "field": "componentCode",
            "width": 71.96095320898259,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "itemCode"
          }, {
            "title": "规格",
            "field": "practicalSealingWidth",
            "width": 23.832825109886567,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "serial"
          }, {
            "title": "单件用量",
            "field": "componentUsage",
            "width": 52.12036822522535,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "colorDesc"
          }, {
            "title": "使用部位",
            "field": "usedPosition",
            "width": 43.493226860807255,
            "align": "center",
            "vAlign": "middle",
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "storageCode"
          }, {
            "title": "备注",
            "field": "remark",
            "width": 99.79363808018972,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "deliveryDate"
          }, {
            "title": "",
            "field": "color_0",
            "width": 64.31633626363534,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "colors",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }, {
            "title": "",
            "field": "color_1",
            "width": 58.64849955892088,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "color_1",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }, {
            "title": "",
            "field": "color_2",
            "width": 60.27324419012385,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "color_2",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }, {
            "title": "",
            "field": "color_3",
            "width": 66.79824625187398,
            "colspan": 1,
            "rowspan": 1,
            "checked": true,
            "columnId": "color_3",
            styler: function (value,row,index,options) {
              return {
                position: 'relative',
              }
            }
          }]
        ]
      },
      "printElementType": {
        "title": "表格",
        "type": "tableCustom"
      }
    }, {
      "options": {
        "left": 214.5,
        "top": 763.5,
        "height": 9.75,
        "width": 136.5,
        "title": "技术部确认",
        "field": "productionManagerInfo"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 445.5,
        "top": 763.5,
        "height": 9.75,
        "width": 135,
        "title": "设计部确认",
        "field": "businessInfo"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 9,
        "top": 763.5,
        "height": 9.75,
        "width": 130.5,
        "title": "制表",
        "field": "userName",
        "testData": "张三"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 214.5,
        "top": 780,
        "height": 9.75,
        "width": 138,
        "title": "日期"
      },
      "printElementType": {
        "type": "text"
      }
    }, {
      "options": {
        "left": 447,
        "top": 781.5,
        "height": 9.75,
        "width": 135,
        "title": "日期"
      },
      "printElementType": {
        "type": "text"
      }
    }],
    "paperNumberLeft": 562.5,
    "paperNumberTop": 801,
    "topOffset": 16,
    "orient": 2
  }]
}